import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const generateRouter = (routes = [], { base = '', mode, ...args }) => {
  mode = mode || (process.env.NODE_ENV === 'production' ? 'history' : 'hash')

  if (process.env.NODE_ENV !== 'production') {
    base = location.pathname + '/'
  }

  if (/\/\w{2}\/mobile/.test(location.pathname)) {
    base = base.replace(/^\/(\w{2})/, '/$1/mobile')
  }

  return new VueRouter({
    base,
    mode,
    routes,
    // scrollBehavior: () => ({ y: 0 })
    ...args
  })
}

export default generateRouter
